import loader from './pageLoader';
import loaderApp from './appLoader';
import App from '../containers/HomeApp';

loader(() => loaderApp(App, () => module.hot.accept()));
